export default "__VITE_ASSET__BH46RSCh__"